import SyncType from "types/sync-type";

const useSyncTypeGuard = (syncType: SyncType | undefined) => {
  if (syncType !== "Billing" && syncType !== "Product")
    throw new Error(`Unsupported sync type: ${syncType}`);
};

export default useSyncTypeGuard;
